import React, { useState } from 'react';
import SearchView from '../ui/SearchView';
import Button from '../ui/Button';

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="w-full bg-global-5">
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-center items-center py-4 sm:py-6 lg:py-7 -ml-[255px] sm:-ml-[340px] lg:-ml-[510px]">
          {/* Logo Section */}
          <div className="flex flex-col gap-1 justify-center items-center w-[57px] sm:w-[86px] lg:w-[114px]">
            <img 
              src="assets/images/logo.jpg" 
              className="w-[57px] h-[13px] sm:w-[86px] sm:h-[20px] lg:w-[114px] lg:h-[26px]" 
              alt="Monito Logo" 
            />
            <img 
              src="/images/img_group_teal_900.svg" 
              className="w-[26px] h-[3px] sm:w-[40px] sm:h-[4px] lg:w-[54px] lg:h-[6px]" 
              alt="Logo accent" 
            />
          </div>

          {/* Hamburger Menu Icon (Mobile only) */}
          <button 
            className="block lg:hidden ml-4 p-2" 
            aria-label="Open menu"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <div className="w-6 h-0.5 bg-global-text4 mb-1"></div>
            <div className="w-6 h-0.5 bg-global-text4 mb-1"></div>
            <div className="w-6 h-0.5 bg-global-text4"></div>
          </button>

          {/* Navigation Menu */}
          <nav className={`${menuOpen ? 'block' : 'hidden'} lg:block absolute lg:relative top-full lg:top-auto left-0 lg:left-auto w-full lg:w-auto bg-global-6 lg:bg-transparent shadow-lg lg:shadow-none z-50 lg:z-auto ml-0 lg:ml-12`}>
            <div className="flex flex-col lg:flex-row gap-4 lg:gap-12 justify-center items-center p-4 lg:p-0">
              <button 
                role="menuitem"
                className="text-sm sm:text-base lg:text-[16px] font-svn-gilroy font-bold leading-[17px] text-global-text4 hover:text-global-text2 transition-colors"
              >
                Home
              </button>
              <button 
                role="menuitem"
                className="text-sm sm:text-base lg:text-[16px] font-svn-gilroy font-bold leading-[17px] text-global-text4 hover:text-global-text2 transition-colors"
              >
                Category
              </button>
              <button 
                role="menuitem"
                className="text-sm sm:text-base lg:text-[16px] font-svn-gilroy font-bold leading-[17px] text-global-text4 hover:text-global-text2 transition-colors"
              >
                About
              </button>
              <button 
                role="menuitem"
                className="text-sm sm:text-base lg:text-[16px] font-svn-gilroy font-bold leading-[17px] text-global-text4 hover:text-global-text2 transition-colors"
              >
                Contact
              </button>
            </div>
          </nav>

          {/* Search and Actions */}
          <div className="hidden lg:flex gap-[14px] justify-center items-center ml-9">
            <SearchView 
              placeholder="Search something here!"
              leftIcon="/images/u_search.svg"
              rightIcon=""
              value=""
              onChange={() => {}}
              className="flex-1"
            />
            
            <Button 
              variant="primary"
              onClick={() => {}}
              className="bg-global-1 text-global-8 rounded-lg px-4 sm:px-6 lg:px-7 py-2 sm:py-2.5 lg:py-3"
            >
              Join the community
            </Button>

            {/* Currency Selector */}
            <div className="flex gap-[6px] justify-center items-center p-2">
              <img 
                src="assets/images/img_frame_45.svg" 
                className="w-[20px] h-[20px]" 
                alt="" 
              />
              <span className="text-sm sm:text-base lg:text-[16px] font-svn-gilroy font-medium leading-[17px] text-global-text3">
                VND
              </span>
              <img 
                src="assets/images/img_arrow_down.svg" 
                className="w-[24px] h-[24px]" 
                alt="" 
              />
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;